/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
  NgxIntlTelInputModule,
} from 'ngx-intl-tel-input';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../api.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { routes } from '../../shared/routes/routes';
import { CommonStandaloneImports } from '../../shared/common/common-standalone-imports';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  first,
  takeUntil,
} from 'rxjs/operators';
import { ProfileSettingsModule } from '../patients/profile-settings/profile-settings.module';
import { CommonService } from '../../shared/common/common.service';
import { take } from 'rxjs/operators';

declare var bootstrap: any;
@Component({
  standalone: true,
  selector: 'dependent-modal',
  imports: [
    ...CommonStandaloneImports,
    NgxIntlTelInputModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    NgSelectModule,
    ProfileSettingsModule,
  ],
  templateUrl: './dependent-modal.component.html',
  styleUrls: ['./dependent-modal.component.scss'],
})
export class DependentModalComponent implements OnInit, AfterViewInit {
  @ViewChild('dependentModal') dependentModal!: ElementRef;
  @ViewChild('otpModalRef') otpModalRef!: ElementRef;
  @Output() caregiverAssigned = new EventEmitter<any>();

  dependentForm: any;
  existingMemberForm: any;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];

  public isSubmitted: boolean = false;
  uploadedFileName: string = '';
  separateDialCode = false;
  public errorMessage: string = '';
  maskedPhone: string = '';
  numberExist: any;

  public routes = routes;
  date = new Date();
  @ViewChild('dp') birthdatepicker: any;
  userProfiles: any;
  modalElement: any;
  dobsDatepickerConfig: any;

  public oneTimePassword: any = {
    data1: '',
    data2: '',
    data3: '',
    data4: '',
    data5: '',
    data6: '',
  };
  otpTouched: { [key: string]: boolean } = {};
  interval: any;
  countdown: number = 45;
  memberData: any;
  contactNumberError: boolean = false;
  payloadData: any;
  dependentDetails: any;
  users: any[] = [];
  caregiverList: any[] = [];
  searchSubject = new Subject<string>();
  selecteduser: any = null;
  destroy$ = new Subject<void>();
  selectedPatientName: any = '';
  selectedCaregiverId: any = '';
  selectedCaregiver: any = null;
  isDropdownOpen = false;
  otpModalType: 'ADD_MEMBER' | 'ASSIGN_CAREGIVER' = 'ADD_MEMBER';
  becomeCaregiver: any = null;
  caregiverPayload: any = null;
  successCaregiverData: any = null;
  otpSource: 'ADD_MEMBER' | 'EXISTING_MEMBER' | 'ASSIGN_CAREGIVER' | null =
    null;
  isSearched = false;
  selectedDuration: string = '';
  customStartDate: string = '';
  customEndDate: string = '';
  dateError: boolean = false;
  todayDate: string = '';

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private tosterService: ToastrService,
    private router: Router,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    const today = new Date();
    this.todayDate = today.toISOString().split('T')[0];
    this.dobsDatepickerConfig = {
      showWeekNumbers: false,
      maxDate: new Date(),
      dateInputFormat: 'YYYY-MM-DD',
      adaptivePosition: true,
      returnFocusToInput: true,
      selectFromOtherMonth: true,
      containerClass: 'custom-datepicker-member',
    };

    this.dependentForm = this.fb.group(
      {
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        relation: ['', Validators.required],
        gender: ['', Validators.required],
        dob: ['', [Validators.required]],
        hasMobile: [true],
        noMobile: [false],
        phone: [''],
      },
      {
        validators: this.dependentAgeValidator(),
      },
    );

    this.existingMemberForm = this.fb.group(
      {
        patientId: ['', [Validators.required, this.strictPatientIdValidator()]],
        dob: ['', Validators.required],
        relation: ['', Validators.required],
      },
      {
        validators: this.dependentAgeValidator(),
      },
    );

    this.dependentForm
      .get('hasMobile')
      ?.valueChanges.subscribe((value: any) => {
        const phoneControl = this.dependentForm.get('phone');

        if (value) {
          phoneControl?.setValidators([
            Validators.required,
            this.zimbabweMobileValidator(),
          ]);
        } else {
          phoneControl?.clearValidators();
          phoneControl?.setValue('');
        }

        phoneControl?.updateValueAndValidity();
      });

    const hasMobileValue = this.dependentForm.get('hasMobile')?.value;
    this.dependentForm.get('hasMobile')?.setValue(hasMobileValue);

    this.existingMemberForm
      .get('patientId')
      ?.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value: string) => {
        this.selecteduser = null;
        this.isSearched = false;
        if (!value || this.existingMemberForm.get('patientId')?.invalid) {
          this.users = [];
          return;
        }

        const numericPart = value.substring(2);

        this.apiService.searchUser(numericPart).subscribe({
          next: (res: any) => {
            const response = Array.isArray(res) ? res[0] : res;

            if (Array.isArray(response?.data)) {
              this.users = response.data;
            } else if (response?.data) {
              this.users = [response.data];
            } else {
              this.users = [];
            }

            this.users = this.users?.length > 0 ? this.users[0].data : [];
            this.isSearched = true;
          },
          error: () => {
            this.users = [];
            this.isSearched = true;
          },
        });
      });

    this.commonService.resetDependentModal$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.resetAllModals();
      });

    this.commonService.openCaregiverModal$.subscribe(() => {
      this.openCaregiverModal();
    });

    this.commonService.closeProfileModal$.subscribe(() => {
      const modal = document.getElementById('view_profile_modal');
      if (modal) {
        const modalInstance = (window as any).bootstrap.Modal.getInstance(
          modal,
        );
        modalInstance?.hide();
      }
    });

    this.commonService.openSuccessCaregiverModal$.subscribe((data) => {
      this.successCaregiverData = data;
      const modal = document.getElementById(
        'add_success_caregiver_member_modal',
      );

      if (modal) {
        const modalInstance = new (window as any).bootstrap.Modal(modal);
        modalInstance.show();
      }
    });

    if (this.selectedDuration !== 'CUSTOM_DATE') {
      this.customStartDate = '';
      this.customEndDate = '';
      this.dateError = false;
    }
  }

  get isSubmitDisabled(): boolean {
    return (
      !this.selecteduser ||
      !this.existingMemberForm.get('relation')?.value ||
      this.existingMemberForm.invalid
    );
  }

  strictPatientIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) return null;

      const stringValue = String(value);

      if (!stringValue.startsWith('MA')) {
        return { invalidPrefix: true };
      }

      const numericPart = stringValue.substring(2);

      if (!/^\d+$/.test(numericPart)) {
        return { invalidFormat: true };
      }

      return null;
    };
  }

  dependentAgeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const dobControl = group.get('dob');
      const hasMobile = group.get('hasMobile')?.value;

      if (!dobControl?.value) return null;

      const today = new Date();
      const dob = new Date(dobControl.value);

      if (dob > today) {
        return { futureDate: true };
      }

      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      if (age > 65) {
        return { ageExceeded: true };
      }

      if (hasMobile && age < 18) {
        return { under18NotAllowed: true };
      }

      if (age <= 0) {
        return { zeroAgeNotAllowed: true };
      }

      return null;
    };
  }

  zimbabweMobileValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control?.value;
      if (!value) {
        return null;
      }

      if (typeof value === 'object' && value.nationalNumber) {
        value = value.nationalNumber;
      }
      if (typeof value !== 'string') {
        return { invalidZimbabweMobile: true };
      }
      value = value.replace(/\s+/g, '');
      value = value.startsWith('0') ? value.substring(1) : value;
      const zimbabweMobileRegex = /^\d{9}$/;
      return zimbabweMobileRegex.test(value)
        ? null
        : { invalidZimbabweMobile: true };
    };
  }

  onSubmitDependent(): void {
    if (this.dependentForm.invalid) {
      this.dependentForm.markAllAsTouched();
      return;
    }

    this.spinner.show();
    this.otpSource = 'ADD_MEMBER';
    const formValue = this.dependentForm.getRawValue();

    const phone_number =
      formValue.hasMobile && formValue.phone
        ? formValue.phone?.number?.replace(/\s/g, '')
        : '';

    const country_dial_code =
      formValue.hasMobile && formValue.phone ? formValue.phone?.dialCode : '';

    const payload = {
      gender: formValue.gender,
      first_name: formValue.first_name,
      last_name: formValue.last_name,
      relation: formValue.relation,
      dob: new Date(formValue.dob).toISOString().split('T')[0],
      phone_number: phone_number,
      country_dial_code: country_dial_code,
      hasMobile: formValue.hasMobile,
      event_type: 'DEPENDENT',
    };

    if (payload.hasMobile && payload.phone_number) {
      this.sendOtpForDependent(payload, 'add_dependent_modal_form');
    } else {
      this.createDependent(payload);
    }
  }

  sendOtpForDependent(payload: any, sourceModalId: string): void {
    this.spinner.show();
    this.numberExist = payload.phone_number;
    this.apiService.sendOtpDependent(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.tosterService.success(
            res.message || 'OTP sent successfully',
            '',
            {
              timeOut: 4000,
            },
          );

          this.hideSourceModal(sourceModalId);
          this.openOtpModal(payload, 'ADD_MEMBER');
        } else {
          const message = res.message || '';
          if (
            message.includes("You can't add this member because he is admin") ||
            message.includes('User with this phone number already exists')
          ) {
            this.hideSourceModal(sourceModalId);
            this.openAlreadyMemberModal();
          } else {
            this.showError(res?.message);
          }
        }
      },

      error: (err) => {
        this.spinner.hide();

        const message =
          err?.error?.message || err?.error?.error || 'Something went wrong';

        if (
          message.includes("You can't add this member because he is admin") ||
          message.includes('User with this phone number already exists')
        ) {
          this.hideSourceModal(sourceModalId);
          this.openAlreadyMemberModal();
        } else {
          this.showError(message);
        }
      },
    });
  }

  hideSourceModal(modalId: string) {
    const modalEl = document.getElementById(modalId);

    if (modalEl) {
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      modalInstance?.hide();
    }
  }

  openAlreadyMemberModal() {
    const alreadyModalEl = document.getElementById(
      'already_member_register_modal',
    );

    if (alreadyModalEl) {
      const alreadyModalInstance = new bootstrap.Modal(alreadyModalEl);
      alreadyModalInstance.show();
    }
  }

  verifyOtpForDependent(): void {
    const otp = Object.values(this.oneTimePassword).join('');

    if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
      this.isSubmitted = true;
      this.errorMessage = 'Please enter a valid 6 digit OTP.';
      return;
    }

    this.spinner.show();
    this.isSubmitted = false;
    this.errorMessage = '';

    const payload = {
      ...this.payloadData,
      otp: otp,
    };

    this.apiService.verifyOtpDependent(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.otpSource = null;
          const otpModalEl = document.getElementById('otp_modal');
          if (otpModalEl) {
            const modalInstance = bootstrap.Modal.getInstance(otpModalEl);
            modalInstance?.hide();
          }

          if (this.otpModalType === 'ASSIGN_CAREGIVER') {
            this.tosterService.success('OTP successfully verified', '', {
              timeOut: 4000,
            });

            this.commonService.triggerCaregiverOtpSuccess(
              this.caregiverPayload,
            );
            this.selectedCaregiver = null;
            this.resetAssignCaregiverModal();
            return;
          }

          setTimeout(() => {
            this.createDependent(this.payloadData);
          }, 300);
        } else {
          this.showError(res?.message);
        }
      },

      error: (err) => {
        this.spinner.hide();
        this.showError(err?.error?.message || err?.error?.error);
      },
    });
  }

  resendOtpForDependent(): void {
    this.spinner.show();
    const payload = this.payloadData;
    this.apiService.resendOtpDependent(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.tosterService.success(
            res.message || 'OTP sent successfully',
            '',
            {
              timeOut: 4000,
            },
          );

          this.oneTimePassword = {
            data1: '',
            data2: '',
            data3: '',
            data4: '',
            data5: '',
            data6: '',
          };

          this.startTimer();
        } else {
          this.showError(res.message);
        }
      },

      error: (err) => {
        this.spinner.hide();
        this.showError(err?.error?.message || err?.error?.error);
      },
    });
  }

  openOtpModal(
    payload: any,
    type: 'ADD_MEMBER' | 'ASSIGN_CAREGIVER' = 'ADD_MEMBER',
  ) {
    const otpEl = document.getElementById('otp_modal');

    if (!otpEl) return;

    this.payloadData = { ...payload };
    this.otpModalType = type;
    this.maskedPhone = `${payload.country_dial_code} ${payload.phone_number}`;

    const otpInstance = new bootstrap.Modal(otpEl);

    const handler = () => {
      this.startTimer();
      otpEl.removeEventListener('shown.bs.modal', handler);
    };

    otpEl.addEventListener('shown.bs.modal', handler);

    otpInstance.show();
  }

  createDependent(payload: any): void {
    this.spinner.show();

    this.apiService.addDependent(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.dependentDetails = res.data;
          this.tosterService.success(
            res.message || 'Dependent added successfully',
            '',
            {
              timeOut: 4000,
            },
          );

          const dependentModalEl = document.getElementById(
            'add_dependent_modal_form',
          );

          if (dependentModalEl) {
            const dependentModalInstance =
              bootstrap.Modal.getInstance(dependentModalEl);
            dependentModalInstance?.hide();
          }

          this.resetDependentForm();
          this.resetOtpModal();
          this.commonService.triggerRefreshDependentList(true);

          setTimeout(() => {
            const otpEl = document.getElementById('add_success_member_modal');
            if (otpEl) {
              const otpInstance = new bootstrap.Modal(otpEl);
              otpInstance.show();
            }
          }, 400);
        } else {
          this.showError(res?.message);
        }
      },

      error: (err) => {
        this.spinner.hide();
        this.showError(err?.error?.message || err?.error?.error);
      },
    });
  }

  cleanInput(event: KeyboardEvent) {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const isLetter = /^[a-zA-Z]$/.test(key);
    const isSpace = key === ' ';
    const isControlKey = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ].includes(key);

    if (
      !isLetter &&
      !(isSpace && value.length > 0 && !value.endsWith(' ')) &&
      !isControlKey
    ) {
      event.preventDefault();
    }
  }

  blockInvalidKeys(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  closePopup(type: any) {
    this.otpSource = null;
    if (type == 'dependent') {
      this.resetDependentForm();
    } else if (type === 'profile') {
      this.commonService.resetProfileForm();
    } else if (type == 'existing') {
      this.resetAllModals();
    } else {
      if (this.birthdatepicker) {
        this.birthdatepicker.bsValue = null;
      }
    }
  }

  ngAfterViewInit() {
    const modal = document.getElementById('assign_caregiver_modal');

    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => {
        this.resetAssignCaregiverModal();
      });
    }

    const otpEl = document.getElementById('otp_modal');

    if (!otpEl) return;

    otpEl.addEventListener('hidden.bs.modal', () => {
      this.resetOtpModal();
    });
  }

  resetDependentForm() {
    this.dependentForm.reset();

    this.dependentForm.patchValue({
      hasMobile: true,
      noMobile: false,
      gender: '',
      relation: '',
      dob: '',
    });

    const phoneControl = this.dependentForm.get('phone');
    phoneControl?.setValidators([
      Validators.required,
      this.zimbabweMobileValidator(),
    ]);
    phoneControl?.updateValueAndValidity();
    this.payloadData = {};
  }

  resetOtpModal(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    this.oneTimePassword = {
      data1: '',
      data2: '',
      data3: '',
      data4: '',
      data5: '',
      data6: '',
    };

    this.otpTouched = {};
    this.errorMessage = '';
    this.isSubmitted = false;
  }

  onMobileOptionChange(type: string) {
    const phoneControl = this.dependentForm.get('phone');

    if (type === 'hasMobile') {
      this.dependentForm.patchValue({
        hasMobile: true,
        noMobile: false,
      });

      phoneControl?.setValidators([
        Validators.required,
        this.zimbabweMobileValidator(),
      ]);
    } else {
      this.dependentForm.patchValue({
        hasMobile: false,
        noMobile: true,
      });

      phoneControl?.clearValidators();
      phoneControl?.setValue(null);
    }

    phoneControl?.updateValueAndValidity();
    this.dependentForm.updateValueAndValidity();
  }

  handleDateOfBirthSelection(ev: any) {
    if (!ev) return;

    const selectedDate = new Date(ev);
    const today = new Date();

    if (selectedDate > today) {
      this.tosterService.error('Date of Birth cannot be in the future');
      this.dependentForm.get('dob')?.reset();
      return;
    }

    this.dependentForm.get('dob')?.setValue(selectedDate);
  }

  validateLoginNumber(ev: any) {
    const rawValue = ev?.target?.value || '';
    const onlyDigits = rawValue.replace(/\D/g, '');
    ev.target.value = onlyDigits;
    const expectedLength = onlyDigits.startsWith('0') ? 10 : 9;
    this.contactNumberError = onlyDigits.length !== expectedLength;
  }

  blockNonNumeric(event: any) {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete',
    ];

    if (allowedKeys.includes(event.key)) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    const inputValue = (event.target as HTMLInputElement).value;
    const digits = inputValue.replace(/\D/g, '');

    const cursorPos = (event.target as HTMLInputElement).selectionStart || 0;
    const expectedLength = digits.startsWith('0') ? 10 : 9;

    if (digits.length >= expectedLength && cursorPos === digits.length) {
      event.preventDefault();
    }
  }

  public allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete',
    ];

    if (allowedKeys.includes(event.key)) {
      this.errorMessage = '';
      return;
    }

    if (event.key === 'Unidentified' || event.key.length > 1) {
      return;
    }

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
      this.errorMessage = 'Only numbers (0–9) are allowed.';
    }
  }

  public tiggerBackspace(data: string, box: string): void {
    if (data) return;

    const current = parseInt(box.split('-')[1], 10);
    const prev = current - 1;

    if (prev >= 1) {
      document.getElementById(`digit-${prev}`)?.focus();
    }
  }

  onOtpInput(ev: any, currentIndex: number): void {
    let value = ev.target.value || '';

    value = value.replace(/\D/g, '').slice(-1);
    ev.target.value = value;
    this.oneTimePassword['data' + currentIndex] = value;

    if (value && currentIndex < 6) {
      const nextBox = document.getElementById(`digit-${currentIndex + 1}`);
      nextBox?.focus();
    }
  }

  startTimer(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    this.countdown = 45;

    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.interval);
        this.interval = null;
      }
    }, 1000);
  }

  public validateOtp(): void {
    const otp = Object.values(this.oneTimePassword).join('');

    if (otp.length === 6 && /^[0-9]{6}$/.test(otp)) {
      this.errorMessage = '';
      this.isSubmitted = false;
    }
  }

  handlePaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.trim().replace(/\D/g, '').split('');
    if (digits.length > 0) {
      digits.slice(0, 6).forEach((digit, index) => {
        this.oneTimePassword['data' + (index + 1)] = digit;
        const nextInput = document.getElementById(
          `digit-${index + 1}`,
        ) as HTMLElement;
        nextInput?.focus();
      });
    }
    event.preventDefault();
  }

  goBack() {
    const otpEl = document.getElementById('otp_modal');
    const otpModal = bootstrap.Modal.getInstance(otpEl!);
    otpModal?.hide();

    setTimeout(() => {
      if (this.otpSource === 'ADD_MEMBER') {
        this.openDependentModal();
      } else if (this.otpSource === 'EXISTING_MEMBER') {
        this.openExistingMemberModal();
      } else if (this.otpSource === 'ASSIGN_CAREGIVER') {
        this.openAssignCaregiverModal();
      }
    }, 300);
  }

  openDependentModal() {
    const modal = new bootstrap.Modal(
      document.getElementById('add_dependent_modal_form')!,
    );
    modal.show();
  }

  openExistingMemberModal() {
    const modal = new bootstrap.Modal(
      document.getElementById('add_existing_member_modal')!,
    );
    modal.show();
  }

  openAssignCaregiverModal() {
    const modal = new bootstrap.Modal(
      document.getElementById('assign_caregiver_modal')!,
    );
    modal.show();
  }

  markOtpTouched(num: number) {
    this.otpTouched['data' + num] = true;
  }

  selectUser(user: any) {
    this.selecteduser = user;
    this.existingMemberForm.patchValue({
      patientId: 'MA' + user.user_id,
      dob: user.dob ? new Date(user.dob) : '',
    });
    this.users = [];
    this.isSearched = false;
  }

  onExistingMemberSubmit() {
    if (this.existingMemberForm.invalid) {
      this.existingMemberForm.markAllAsTouched();
      return;
    }

    const payload = {
      gender: this.selecteduser?.gender,
      first_name: this.selecteduser?.first_name,
      last_name: this.selecteduser?.last_name,
      relation: this.existingMemberForm.value.relation,
      dob: new Date(this.existingMemberForm.value.dob)
        .toISOString()
        .split('T')[0],
      phone_number: this.selecteduser?.phone,
      country_dial_code: this.selecteduser?.country_dial_code,
      event_type: 'DEPENDENT',
    };

    this.otpSource = 'EXISTING_MEMBER';
    this.sendOtpForDependent(payload, 'add_existing_member_modal');
  }

  onSearch(value: string) {
    this.searchSubject.next(value);
  }

  manageMember(type: any) {
    let modal;

    if (type == 'add-member') {
      modal = document.getElementById('add_success_member_modal');
    } else {
      modal = document.getElementById('add_success_caregiver_member_modal');
    }

    this.commonService.triggerRefreshDependentList(true);

    if (modal) {
      const modalInstance = (window as any).bootstrap.Modal.getInstance(modal);
      modalInstance?.hide();
    }
  }

  existingPopup() {
    const alreadyModalEl = document.getElementById(
      'already_member_register_modal',
    );

    const existingModalEl = document.getElementById(
      'add_existing_member_modal',
    );

    if (alreadyModalEl) {
      const alreadyModalInstance =
        bootstrap.Modal.getOrCreateInstance(alreadyModalEl);
      alreadyModalInstance.hide();
    }

    if (existingModalEl) {
      const existingModalInstance =
        bootstrap.Modal.getOrCreateInstance(existingModalEl);
      existingModalInstance.show();
    }
  }

  editNumber() {
    const alreadyModalEl = document.getElementById(
      'already_member_register_modal',
    );

    const dependentModalEl = document.getElementById(
      'add_dependent_modal_form',
    );

    if (alreadyModalEl) {
      const alreadyModalInstance =
        bootstrap.Modal.getOrCreateInstance(alreadyModalEl);
      alreadyModalInstance.hide();
    }

    if (dependentModalEl) {
      const dependentModalInstance =
        bootstrap.Modal.getOrCreateInstance(dependentModalEl);
      dependentModalInstance.show();
    }
  }

  maskPhone(phone: string | null): string {
    if (!phone) return 'N/A';

    if (phone.length <= 4) return phone;

    const firstTwo = phone.slice(0, 2);
    const lastTwo = phone.slice(-2);
    const masked = '*'.repeat(phone.length - 4);

    return `${firstTwo}${masked}${lastTwo}`;
  }

  maskName(name: string | null): string {
    if (!name) return '';

    if (name.length <= 2) return name;

    const firstChar = name.charAt(0);
    const lastChar = name.charAt(name.length - 1);
    const masked = '*'.repeat(name.length - 2);

    return `${firstChar}${masked}${lastChar}`;
  }

  getCaregiverList(): void {
    this.spinner.show();

    this.apiService.getCaregiver().subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.caregiverList = res.data || [];
        } else {
          this.showError(res?.message);
        }
      },
      error: (err) => {
        this.showError(err?.error?.message || err?.error?.error);
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  showError(message?: string): void {
    this.tosterService.error(message || 'Something went wrong', '', {
      timeOut: 4000,
    });
  }

  continueAssign() {
    if (!this.selectedCaregiverId) {
      this.tosterService.error('Please select caregiver');
      return;
    }

    if (!this.selectedDuration) {
      this.tosterService.error('Please select duration');
      return;
    }

    if (this.selectedDuration === 'CUSTOM_DATE') {
      if (!this.customStartDate || !this.customEndDate) {
        this.dateError = true;
        return;
      }

      if (this.customEndDate < this.customStartDate) {
        this.dateError = true;
        return;
      }

      this.dateError = false;
    }

    this.otpSource = 'ASSIGN_CAREGIVER';
    const payload = {
      caregiver_id: this.selectedCaregiverId,
      duration: this.selectedDuration,
      dob: new Date(this.selectedCaregiver.dob).toISOString().split('T')[0],
      country_dial_code: this.selectedCaregiver.country_dial_code,
      phone_number: this.selectedCaregiver.phone,
      event_type: 'CAREGIVER',
      first_name: this.selectedCaregiver.first_name,
      last_name: this.selectedCaregiver.last_name,
      gender: this.selectedCaregiver.gender,
      age: this.getAge(this.selectedCaregiver.dob),
      startDate:
        this.selectedDuration === 'CUSTOM_DATE' ? this.customStartDate : null,
      endDate:
        this.selectedDuration === 'CUSTOM_DATE' ? this.customEndDate : null,
    };

    this.caregiverPayload = payload;
    this.spinner.show();

    this.apiService.sendOtpDependent(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.tosterService.success(
            res.message || 'OTP sent successfully',
            '',
            { timeOut: 4000 },
          );

          this.commonService.selectedUser$
            .pipe(take(1))
            .subscribe((userData) => {
              this.becomeCaregiver = userData;
            });

          const modalEl = document.getElementById('assign_caregiver_modal');

          if (modalEl) {
            const modalInstance = bootstrap.Modal.getInstance(modalEl);

            modalEl.addEventListener(
              'hidden.bs.modal',
              () => {
                this.openOtpModal(payload, 'ASSIGN_CAREGIVER');
              },
              { once: true },
            );

            modalInstance?.hide();
          }
        } else {
          const message = res.message || '';
          if (
            message.includes("You don't have permission to assign caregiver")
          ) {
            this.showError(res?.message);
          }
        }
      },

      error: (err) => {
        this.spinner.hide();

        const message =
          err?.error?.message || err?.error?.error || 'Something went wrong';

        if (message.includes("You don't have permission to assign caregiver")) {
          this.showError(message);
        }
      },
    });
  }

  resetAllModals() {
    this.resetDependentForm();
    this.resetOtpModal();
    this.otpSource = null;
    this.existingMemberForm.reset();

    this.existingMemberForm.patchValue({
      patientId: '',
      dob: '',
      relation: '',
    });

    this.users = [];
    this.selecteduser = null;
  }

  openCaregiverModal() {
    this.resetAssignCaregiverModal();

    this.commonService.selectedUser$.subscribe((userData) => {
      this.selectedPatientName = `${userData.first_name} ${userData.last_name}`;
    });
    const modal = document.getElementById('assign_caregiver_modal');

    if (modal) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modal, {
        backdrop: 'static',
        keyboard: false,
      });

      bootstrapModal.show();
      this.getCaregiverList();
    }
  }

  resetAssignCaregiverModal(): void {
    this.selectedCaregiver = null;
    this.selectedDuration = '';
    this.isDropdownOpen = false;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectCaregiver(caregiver: any) {
    this.selectedCaregiver = caregiver;
    this.selectedCaregiverId = caregiver.caregiver_id;
    this.isDropdownOpen = false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAge(dob: string | Date): number | null {
    if (!dob) return null;

    const birthDate = new Date(dob);

    if (isNaN(birthDate.getTime())) return null;

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();

    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age >= 0 ? age : null;
  }

  onDurationChange() {
    if (this.selectedDuration !== 'CUSTOM_DATE') {
      this.customStartDate = '';
      this.customEndDate = '';
      this.dateError = false;
    }
  }

  onStartDateChange() {
    if (this.customEndDate && this.customEndDate < this.customStartDate) {
      this.customEndDate = '';
    }
  }
}
